import { FC, useCallback, useEffect, useContext, useMemo } from 'react';
import { Box, Select } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { VariablesContext } from '../context';
import { defaultWorkItemsData, useWorkItemsLazyQuery } from '~/queries';

export const SelectWorkItemFile: FC = () => {
  const { endpoint, variables, setVariables } = useContext(VariablesContext);
  const { t } = useTranslation();

  const [
    { data: { data: workItems } = defaultWorkItemsData, isLoading: isLoadingWorkItems },
    getWorkItems,
  ] = useWorkItemsLazyQuery();

  useEffect(() => {
    if (!variables.processId || !variables.workItemId) return;
    getWorkItems({ scope: 'process', processId: variables.processId });
  }, [variables.workItemId]);

  const fileIds = useMemo(() => {
    return (
      workItems
        ?.find((item) => item.id === variables.workItemId)
        ?.files?.map((file) => {
          return { label: file.name, value: file.id };
        }) || []
    );
  }, [workItems]);

  useEffect(() => {
    setVariables({ fileId: fileIds.length ? fileIds[0].value : undefined });
  }, [fileIds]);

  const onChange = useCallback(
    (fileId: string) => {
      setVariables({ fileId });
    },
    [setVariables],
  );

  const placeholder = isLoadingWorkItems ? t('loading') : t('noWorkItemFiles');

  return !endpoint.includes('fileId') || !variables.workItemId ? null : (
    <Box mb={20}>
      <Select
        label={t('chooseWorkItemFile')}
        items={fileIds}
        onChange={onChange}
        disabled={isLoadingWorkItems || !variables.processId || !fileIds.length}
        value={variables.workItemId}
        placeholder={fileIds.length ? `${t('choose')}...` : placeholder}
      />
    </Box>
  );
};
